import { AssetType, AssetBase } from "../../types/models/AssetBase";

export const getAssetLongName = ({
  name,
  tokenId,
  type,
}: Pick<AssetBase<never>, "type" | "name" | "tokenId">) =>
  type == AssetType.NFT && tokenId ? `${name} #${tokenId}` : name;
